import {env} from './general';
import {getHostNameFromURL} from './url';

export const getDefaultCookieDomain = () => {
  const appUrl = env('REACT_APP_URL');
  const parts = getHostNameFromURL(appUrl).split('.').slice(1);
  return `.${parts.join('.')}`;
};

/**
 *
 * @param {string} name - Name of the cookie
 * @returns {mixed}
 */
export const getCookie = name => {
  const cname = `${name}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  // eslint-disable-next-line fp/no-mutation, no-plusplus
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      // eslint-disable-next-line fp/no-mutation
      c = c.substring(1);
    }
    if (c.indexOf(cname) === 0) {
      return c.substring(cname.length, c.length);
    }
  }
  return '';
};

/**
 * A missing value would be written as the string "undefined", which later
 * reads as a valid cookie, so those are refused.
 *
 * @param {string} name - Name of the cookie
 * @param {string} value - Value of the cookie
 * @param {string} expiry - Expiry time in UTC string
 * @param {string} domain - Domain which cookie belongs to
 *
 * @return {void}
 */
export const setCookie = (
  name,
  value,
  expiry = '',
  domain = getDefaultCookieDomain(),
  options = {}
) => {
  if (value === undefined || value === null) {
    return;
  }
  const cname = `${name}=${value};`;
  const cexpiry = expiry ? `expires=${expiry};` : ``;
  const cdomain = domain ? `domain=${domain};` : ``;
  const sameSite = `SameSite=${options.sameSite || 'Lax'};`;
  const secure = window.location.protocol === 'https:' ? 'Secure;' : '';
  // eslint-disable-next-line fp/no-mutation
  document.cookie = `${cname}${cexpiry}${cdomain}path=/;${sameSite}${secure}`;
};

/**
 *
 * @param {string} name - Name of the cookie
 * @param {string} domain - Domain which cookie belongs to
 *
 * @return {void}
 */
export const deleteCookie = (name, domain = getDefaultCookieDomain()) => {
  const cdomain = domain ? `domain=${domain};` : ``;
  const secure = window.location.protocol === 'https:' ? 'Secure;' : '';
  const base = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;${cdomain}path=/;SameSite=Lax;${secure}`;
  // eslint-disable-next-line fp/no-mutation
  document.cookie = base;
  // eslint-disable-next-line fp/no-mutation
  document.cookie = `${base}Partitioned`;
};

export const clearCookies = () => {
  const cookies = document.cookie.split(';');
  for (const cookie of cookies) {
    const eqPos = cookie.indexOf('=');
    const name = eqPos > -1 ? cookie.substring(0, eqPos).trim() : cookie.trim();
    // eslint-disable-next-line fp/no-mutation
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
  }
};
